import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: "https://9aeccf3c00f44955b1cc2c2dce41f987@o424138.ingest.sentry.io/5355565",
    environment: process.env.REACT_APP_NODE_ENV,
    release: "jazz-groove-website@" + process.env.REACT_APP_CURRENT_VERSION
  });
  